import styled from 'styled-components';
import { CloseButton } from 'react-bootstrap';

export const ButtonClose = styled(CloseButton)`
  flex: 1;
  align-items: center;
  font-size: 2.5rem;
  display: flex;
`;
